import { useRoute, type RouteLocationNormalizedLoaded } from 'vue-router'

// Helper to get typed route params in setup script
// Usage: const route = useTypedRoute<{ id: string }>()
export function useTypedRoute<Params extends Record<string, string | string[]>>() {
  const route = useRoute()
  // Narrow the params type for TS while keeping the same runtime object
  return route as RouteLocationNormalizedLoaded & { params: Readonly<Params> }
}
